import StatusApi from '../data/api/status-api';

class StatusRepository {
  constructor(firebaseConfig, state) {
    this.api = new StatusApi(firebaseConfig, state);
  }

  getAllFollowsLive(follows) {
    return this.api.getAllFollowsLive(follows);
  }

  getAllByUsernameLive(username) {
    return this.api.getAllByUsernameLive(username);
  }

  create(userId, status) {
    return this.api.create(userId, status);
  }
}

export default StatusRepository;
